import PersonalInfoForm from "@/components/templates/Checkout/forms/personal-info-form";
import { __ } from "@/lib/i18n/functions";
import { getCheckoutBackRoute } from "@/lib/utils";
import { ChevronLeft } from "lucide-react";
import Link from "next/link";

type CustomerInformationProps = {
  resolution: Resolution;
};

const CustomerInformation = ({ resolution }: CustomerInformationProps) => {
  const [route] = resolution.slugs;
  return (
    <article className="flex-3/5 space-y-5">
      <Link
        href={getCheckoutBackRoute(resolution.locale, route)}
        className="text-primary-light flex w-fit items-center gap-2.5 pr-1 font-medium transition-transform duration-150 ease-in-out active:scale-95 max-md:hidden"
      >
        <ChevronLeft size={24} aria-hidden="true" />
        {__("Return to the previous step", resolution.locale)}
      </Link>
      <h2 className="font-cabinet-grotesk text-2xl font-medium md:text-3xl">
        {__("Personal information", resolution.locale)}
      </h2>
      <hr className="border-primary-light/50" />
      <PersonalInfoForm route={route} locale={resolution.locale} />
    </article>
  );
};

export default CustomerInformation;
